module.exports = __webpack_public_path__ + "static/media/shaved-ice.1ff96570.svg";